"use strict";
// DEPRECATION NOTICE: prefer TimelineBodyWrapper (once TimelineBodyEditor is available) CRM-Issues/3655
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _SanitizeConfiguration = _interopRequireDefault(require("crm_ui/utils/SanitizeConfiguration"));

var _SanitizeHelper = require("crm_ui/utils/SanitizeHelper");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var Sanitize = _SanitizeConfiguration.default.configureSanitize();

var BodyContent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BodyContent, _PureComponent);

  function BodyContent() {
    var _this;

    (0, _classCallCheck2.default)(this, BodyContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BodyContent).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BodyContent, [{
    key: "getFormattedText",
    value: function getFormattedText() {
      var formattedHTML;
      var formattedPlainText;
      var _this$props = this.props,
          body = _this$props.body,
          linkTwitter = _this$props.linkTwitter,
          plainText = _this$props.plainText,
          sanitizeConfig = _this$props.sanitizeConfig,
          isExpanded = _this$props.isExpanded;

      if (plainText && !body) {
        formattedPlainText = (0, _SanitizeHelper.formatPlainText)(plainText, linkTwitter);
      } else {
        formattedHTML = (0, _SanitizeHelper.formatRichText)(body, sanitizeConfig, linkTwitter, isExpanded);
      }

      if (!formattedHTML && !formattedPlainText) {
        formattedPlainText = (0, _SanitizeHelper.formatPlainText)(body);
      }

      return {
        formattedHTML: formattedHTML,
        formattedPlainText: formattedPlainText
      };
    }
  }, {
    key: "renderBodyContent",
    value: function renderBodyContent() {
      var bodyContent;
      var onToggleEditBody = this.props.onToggleEditBody;

      var _this$getFormattedTex = this.getFormattedText(),
          formattedHTML = _this$getFormattedTex.formattedHTML,
          formattedPlainText = _this$getFormattedTex.formattedPlainText;

      if (formattedHTML) {
        bodyContent = _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: formattedHTML
          }
        });
      } else if (typeof formattedPlainText === 'string') {
        bodyContent = _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: formattedPlainText
          }
        });
      } else if (formattedPlainText.length === 1 && formattedPlainText[0] === '') {
        bodyContent = null;
      } else {
        // warning: dont use index as a key for dynamic content. This is static.
        bodyContent = formattedPlainText.map(function (line, index) {
          return _react.default.createElement("p", {
            key: index,
            dangerouslySetInnerHTML: {
              __html: line
            }
          });
        });
      }

      if (!bodyContent) {
        return null;
      }

      return _react.default.createElement("div", {
        onClick: onToggleEditBody,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        "data-selenium-test": "body-content-text-" + this.props.dataSeleniumKey
      }, bodyContent);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("span", {
        "data-selenium-test": "body-content-" + this.props.dataSeleniumKey,
        className: "timeline-body-content"
      }, this.renderBodyContent());
    }
  }]);
  return BodyContent;
}(_PureComponent2.default);

BodyContent.propTypes = {
  body: _propTypes.default.string,
  dataSeleniumKey: _propTypes.default.string,
  plainText: _propTypes.default.string,
  linkTwitter: _propTypes.default.bool,
  isExpanded: _propTypes.default.bool,
  onToggleEditBody: _propTypes.default.func,
  sanitizeConfig: _propTypes.default.object
};
BodyContent.defaultProps = {
  horizontalPadding: 4,
  onToggleEditBody: _emptyFunction.default,
  sanitizeConfig: Sanitize.Config.CRM.RELAXED
};
var _default = BodyContent;
exports.default = _default;
module.exports = exports.default;